export default __webpack_public_path__ + "static/media/barra2.19e3ecde.png";